"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMortgageCommonPageState = void 0;
var Pages_1 = require("@/rendering/common/Pages");
exports.defaultMortgageCommonPageState = {
    mortgageSidebar: {
        name: 'Mortgage',
        page: Pages_1.Pages.MORTGAGE,
        children: [
            {
                name: 'Mortgage Repayment',
                link: 'mortgage-repayment',
                page: Pages_1.Pages.MORTGAGE_REPAYMENT,
            },
            {
                name: 'Affordability (By Income)',
                link: 'mortgage-affordability',
                page: Pages_1.Pages.MORTGAGE_AFFORDABLILTY,
            },
            {
                name: 'Affordability (By Payment)',
                link: 'mortgage-affordability-by-payment',
                page: Pages_1.Pages.MORTGAGE_AFFORDABLILTY_BY_PAYMENT,
            },
            {
                name: 'Refinancing',
                link: 'mortgage-refinancing',
                page: Pages_1.Pages.MORTGAGE_REFINANCE,
            }
        ]
    },
};
